const zoomChange = 5.64;

const getStatesLayer = (stateColors, isCountyLevel, validStates) => {
  return {
    id: 'states',
    type: 'fill',
    'source-layer': 'cb_2019_us_state_500k-ayxjv6',
    paint: {
      'fill-color':
        stateColors === null || stateColors.length < 4
          ? 'rgba(0,0,0,0)'
          : stateColors,
    },
    filter: [
      'in',
      ['get', 'STATEFP'],
      [ 'literal', validStates ],
    ],
    maxzoom: isCountyLevel ? 3 : zoomChange,
  };
};

const getCountiesLayer = (countyColors, isCountyLevel, validStates) => {
  return {
    id: 'counties',
    type: 'fill',
    'source-layer': 'cb_2019_us_county_500k-9krtz6',
    paint: {
      'fill-outline-color': 'rgba(0,0,0,0.2)',
      'fill-color':
        countyColors === null || countyColors.length < 4
          ? 'rgba(0,0,0,0)'
          : countyColors,
    },
    filter: [
      'in',
      ['get', 'STATEFP'],
      [ 'literal', validStates ],
    ],
    minzoom: isCountyLevel ? 3 : zoomChange,
  };
};

const getCountyLines = (isCountyLevel, validStates) => {
  return {
    id: 'counties-lines',
    type: 'line',
    'source-layer': 'cb_2019_us_county_500k-9krtz6',
    paint: {
      'line-color': 'rgba(179,179,179,1)',
      'line-width': 1,
    },
    filter: [
      'in',
      ['get', 'STATEFP'],
      [ 'literal', validStates ],
    ],
    minzoom: isCountyLevel ? 3 : zoomChange,
  };
};

const highlightStateLayer = {
  id: 'state-highlighted',
  type: 'line',
  'source-layer': 'cb_2019_us_state_500k-ayxjv6',
  paint: {
    'line-width': 3,
    'line-color': 'rgba(0, 0, 0, 0.5)',
  },
  layout: {
    'line-join': 'round',
  },
};

const highlightCountyLayer = {
  id: 'county-highlighted',
  type: 'line',
  'source-layer': 'cb_2019_us_county_500k-9krtz6',
  paint: {
    'line-width': 3,
    'line-color': 'rgba(0, 0, 0, 0.5)',
  },
  layout: {
    'line-join': 'round',
  },
};

export {
  getStatesLayer,
  getCountiesLayer,
  getCountyLines,
  highlightStateLayer,
  highlightCountyLayer,
  zoomChange,
};
